import { render, staticRenderFns } from "./riskPrevention.vue?vue&type=template&id=6945a0ce&scoped=true"
import script from "./riskPrevention.vue?vue&type=script&lang=js"
export * from "./riskPrevention.vue?vue&type=script&lang=js"
import style0 from "./riskPrevention.vue?vue&type=style&index=0&id=6945a0ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6945a0ce",
  null
  
)

export default component.exports